import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import Favicon from "components/fav-icon/Favicon";


import LinkIconSVG from "assets/svg/link-icon";
import VideoFileIconSVG from "assets/svg/video-file-icon";
import VideoEmbedIconSVG from "assets/svg/video-embed-icon";
import AudioIconSVG from "assets/svg/audio-icon";
import ImageIconSVG from "assets/svg/image-icon";
import TextIconSVG from "assets/svg/text-icon";

/**
 * buttonName = for button text inside button container
 * buttonWidth = custom width for button
 * buttonClass = customized class for button
 * buttonTextClass = custom classname for button text inside
 * onClick = function for clicking the button
 */

const MediaButton = ({
  buttonData = {},
  buttonName = "",
  buttonWidth,
  buttonClass = "defaultButton",
  buttonRadius = "6px",
  buttonTextClass = "defaultButtonText",
  hover = "",
  iconPosition = "right",
  icon = null,
  loadingIcon = null,
  onClick = () => {},
  disabled = false,
  link = false,
  path = "/",
  ...props
}) => {
  let inputIcon = buttonData?.url ? <Favicon domain={buttonData.url} hasFavIconFile={buttonData?.fav_icon?.url || null}/> : <LinkIconSVG className="text-lg" />;
  if (buttonData.sub_type?.name === "Link" ) {
    inputIcon = buttonData?.url ? <Favicon domain={buttonData.url} hasFavIconFile={buttonData?.fav_icon?.url || null}/> :
    <LinkIconSVG className="text-lg" />;
  }
  else if (buttonData.sub_type?.name === "Video Embed" || buttonData.sub_type?.name === "Watch") {
    inputIcon = buttonData?.url ? <Favicon domain={buttonData.url} hasFavIconFile={buttonData?.fav_icon?.url || null}/> :
    <VideoEmbedIconSVG className="text-lg" />;
  }
  else if (buttonData.sub_type?.name === "Audio File") {
    inputIcon = <AudioIconSVG className="text-lg" />;
  }
  else if (buttonData.sub_type?.name === "Multiple Images") {
    inputIcon = <ImageIconSVG className="text-2xl" />;
  }
  else if (buttonData.sub_type?.name === "Upload") {
    if(buttonData?.label === "Watch"){
      inputIcon = buttonData?.url ? <Favicon domain={buttonData.url} hasFavIconFile={buttonData?.fav_icon?.url || null}/> :
      <VideoFileIconSVG className="text-lg" />;
    }
    else {
      inputIcon = buttonData?.url ? <Favicon domain={buttonData.url} hasFavIconFile={buttonData?.fav_icon?.url || null}/> : <TextIconSVG className="text-lg" />;
    }
  }
  if (!link) {
    return (
      <div className="relative cursor-pointer h-full" onClick={onClick}>
        <div className="h-full z-10 absolute items-center flex w-[60px] bg-thBg justify-center rounded-l-md border-2 border-gray border-r-0">
          {inputIcon}
        </div>
        
      <button
        className={buttonClass + ` ${!disabled && `hover:${hover}`}`}
        disabled={disabled}
        style={
          buttonWidth
            ? {
                width: buttonWidth,
                borderRadius: buttonRadius,
                opacity: (disabled || loadingIcon) && 0.5,
                cursor: disabled && "default",
              }
            : {
                borderRadius: buttonRadius,
                opacity: (disabled || loadingIcon) && 0.5,
                cursor: disabled && "default",
              }
        }
        {...props}>
        <div className={buttonTextClass + " text-start ml-14 xl:ml-18 mr-4"}>
          {iconPosition === "left" && icon}
          <span className="limit-2-lines">{buttonName}</span>
          {iconPosition === "right" && icon}
          {loadingIcon && loadingIcon}
        </div>
      </button>
      </div>
    );
  } else {
    return (
      <div className="relative">
      <div className="h-full absolute items-center flex w-[60px] bg-thBg justify-center rounded-l-md border-2 border-gray border-r-0">
        {inputIcon}
      </div>
      <Link
        to={path}
        className={buttonClass + ` ${!disabled && `hover:${hover}`}`+  + " text-start ml-14"}
        style={
          buttonWidth
            ? {
                width: buttonWidth,
                borderRadius: buttonRadius,
                opacity: disabled && 0.5,
                cursor: disabled && "default",
              }
            : {
                borderRadius: buttonRadius,
                opacity: disabled && 0.5,
                cursor: disabled && "default",
              }
        }>
      </Link>
      </div>
    );
  }
};

export default MediaButton;
